import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';
import { FatDoctoIDI } from '../interfaces/fat-docto-i-di';

@Injectable({
  providedIn: 'root'
})
export class FatDoctoIDIService {

  readonly path = '/lancamento/item/declaracao-importacao';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }


  create(uuidDoFatDoctoI: string): Observable<FatDoctoIDI> {
    return this.http.post<FatDoctoIDI>(`${this.jwtAuthService.apiUrl + this.path}/${uuidDoFatDoctoI}`, null);
  }

  saveOrUpdate(fatDoctoIDI: FatDoctoIDI): Observable<FatDoctoIDI> {
    console.log(`${this.jwtAuthService.apiUrl + this.path}`);
    console.log(`FatDoctoIDIService saveOrUpdate fatDoctoIDI`, fatDoctoIDI);
      
    return this.http.put<FatDoctoIDI>(`${this.jwtAuthService.apiUrl + this.path}`, fatDoctoIDI);
  }

  // saveOrUpdateItem(item: FatDoctoI): Observable<FatDoctoI> {
  //   return this.http.put<FatDoctoI>(`${this.jwtAuthService.apiUrl + this.path}/item/web`, item);
  // }

  getFatDoctoIDI(id: number ): Observable<FatDoctoIDI> {
    return this.http.get<FatDoctoIDI>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getFatDoctoIDIPage(uuidDoFatDoctoI: string, page?: number, size?: number, order?: string, direction?: string): Observable<PageResult<FatDoctoIDI>> {
    return this.http.get<PageResult<FatDoctoIDI>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?uuidDoFatDoctoI=${uuidDoFatDoctoI}&page=${page}&size=${size}&order=${order}&direction=${direction}`);
  }

  // TODO - Implementar o search no backend
  getFatDoctoIDIPageSearch(page?: number, size?: number,  search?: string, order?: string, direction?: string): Observable<PageResult<FatDoctoIDI>> {
    return this.http.get<PageResult<FatDoctoIDI>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  deleteFatDoctoIDI(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

}
